import languageData from "../containers/Topbar/languageData";

export default function getLocale(code) {
  return languageData.find((lng) => lng.locale === code) || {};
}
